// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p7uJj0Pa0OI0SA9wASI4{flex-direction:column;display:flex}.lLXa6ecwNl8Krw6HEFdx{flex-direction:column;gap:8px;margin-bottom:24px;display:flex}.df3d9O9dcd8CMec6Gybk{color:var(--green-90);align-items:center;gap:8px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentWrapper": `p7uJj0Pa0OI0SA9wASI4`,
	"checkboxBlock": `lLXa6ecwNl8Krw6HEFdx`,
	"checkboxItem": `df3d9O9dcd8CMec6Gybk`
};
export default ___CSS_LOADER_EXPORT___;
